import {advice_url} from './default.json';
import axios from 'axios';
export const Advice = async () =>{
    const data =  await axios.get((advice_url))
    return data.data;
} 